import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import CheckBox from './CheckBox';
import './CheckBox.css';

const CheckBoxContainer = ({ options, onChange, initialValues = [], errors = [] }) => {
  const [selectedOptions, setSelectedOptions] = useState(initialValues);
  const containerRef = useRef(null);

  useEffect(() => {
    setSelectedOptions(initialValues);
  }, [initialValues]);

  useEffect(() => {
    if (containerRef.current) {
      gsap.from(containerRef.current.children, {
        y: 20,
        stagger: 0.1,
        duration: 0.5,
        ease: "power2.out"
      });
    }
  }, []);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    const newSelectedOptions = checked
      ? [...selectedOptions, value]
      : selectedOptions.filter((option) => option !== value);

    setSelectedOptions(newSelectedOptions);
    onChange && onChange(newSelectedOptions);

    const checkboxInput = containerRef.current.querySelector(`input[value="${value}"]`);
    if (checkboxInput) {
      gsap.fromTo(
        checkboxInput,
        { scale: 1 },
        { scale: 1.3, duration: 0.15, yoyo: true, repeat: 1, ease: "power1.inOut" }
      );
    }
  };

  return (
    <div className="checkbox-container" ref={containerRef}>
      {options.map((option) => (
        <CheckBox
          key={option.value}
          name={option.value}
          label={option.label}
          value={option.value}
          checked={selectedOptions.includes(option.value)}
          onChange={handleCheckboxChange}
          error={errors.includes(option.value)}
        />
      ))}
    </div>
  );
};

export default CheckBoxContainer;
